import React from 'react';

import $ from 'jquery'

class StaticInputFormType extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            timeout: null
        }
    }

    onValueChanged(e) {
        var value = e.target.value;

        if(this.props.maxLength !== undefined){

            value = value.replace(',','.');
            value = value.replace(/[^0-9.]+/g,'');

            if(value > 2){
                value = 2;
            }else if(value < 0){
                value = 0;
            }

            if(value.length > 3){
                value = value.substr(0,3);
            }

            var lengthft = (value * 3.2808).toFixed(2);

            $('#'+this.props.input_name).val(value);
            $('#'+this.props.input_name+'_conversion-ft').text(lengthft);

        }

        clearTimeout(this.state.timeout);

        var onOptionalAttributeChanged = () => { this.props.onOptionalAttributeChanged(this.props.input_name, value); }

        this.setState({timeout: setTimeout(function () {
            onOptionalAttributeChanged();
        }, 500)});

    }
    render() {

        var defaultValue = "";

        if(this.props.checkedAttributes !== null && this.props.input_name in this.props.checkedAttributes){
            defaultValue = this.props.checkedAttributes[this.props.input_name];
        }

        return (
            <div className="neutrik-form-section">
                <input type="text" className="length" name={this.props.input_name} id={this.props.input_name} placeholder={this.props.placeholder} onChange={(e) => this.onValueChanged(e)} defaultValue={defaultValue}/>

                <div className="conversion">
                    {this.props.placeholder === "(in metres)" ? 'm. ' : this.props.name}
                    {this.props.placeholder === "(in metres)" &&
                    <span>(<span id={this.props.input_name + "_conversion-ft"}></span> ft.)</span>
                    }

                </div>
            </div>
        );
    }
}

export default StaticInputFormType;


// WEBPACK FOOTER //
// ./../../htdocs/neutrik-opticalcon_fe/src/components/StaticInputFormType.js